export default (str: string) => {
  if (!str) return;
  return str
    .replace(/[\W_]+/g, ' ')
    .replace(/(\w)(\w*)/g, (m, p1, p2) => p1.toUpperCase() + p2.toLowerCase());
};
